import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';

/**
 * Pestaña de gestión de destinos
 */
const DestinationsTab = ({
  destinations,
  newDestination,
  onNewDestinationChange,
  onAddDestination,
  onDeleteDestination,
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onAddDestination();
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Gestión de Destinos</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex gap-2">
          <Input
            placeholder="Nombre del nuevo destino"
            value={newDestination}
            onChange={(e) => onNewDestinationChange(e.target.value)}
            onKeyPress={handleKeyPress}
            data-testid="new-destination-input"
          />
          <Button onClick={onAddDestination} data-testid="add-destination-btn">
            <Plus size={18} className="mr-1" />
            Añadir
          </Button>
        </div>

        <div className="space-y-2">
          {destinations.map((dest) => (
            <div
              key={dest.id}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              data-testid={`destination-${dest.id}`}
            >
              <span className="font-medium">{dest.name}</span>
              <Button
                variant="destructive"
                size="sm"
                onClick={() => onDeleteDestination(dest.id, dest.name)}
                data-testid={`delete-destination-${dest.id}`}
              >
                <Trash2 size={16} />
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default DestinationsTab;
